import {useParams} from 'react-router'
import {observer} from 'mobx-react-lite'
import {useEffect} from 'react'
import clubStore from '../../../storage/ClubStore'
import GameResult from "../../Games/GameResult";

const ManagerShowGame = () => {
  const args = useParams()
  const contest = clubStore.tournament
  useEffect(() => {
    if (args.id) {
      contest.getGame(args.id)
    }
  }, [args.id])
  return (
    <GameResult game={contest.game} role={"MGR"}/>
  )
}

export default observer(ManagerShowGame)